


import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../Features/Auth/authSlice";
import dashboardReducer from "../Features/Auth/Slice/dashboardSlice";
import bidsReducer from "../Features/Auth/Slice/bidsSlice";
import categoryReducer from "../Features/Auth/Slice/categorySlice";
import prescriptionsReducer from "../Features/Auth/Slice/prescriptionSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    bids: bidsReducer,
    category: categoryReducer,
    prescriptions: prescriptionsReducer,
  },
});